import createCache from '@emotion/cache';

// Shared between the client entry (src/index.jsx) and the SSR entry
// (src/entry-server.jsx) so Emotion's class-name hashing is identical in
// both — needed for MUI's client-side "these styles were already
// server-rendered" dedupe to recognise the server's <style> tags instead
// of re-inserting duplicates. The server creates a *fresh* cache per
// route render (never reused across routes/requests); the client creates
// exactly one, once, at module load.
const createEmotionCache = () => createCache({ key: 'css' });

export default createEmotionCache;
